const anchor = (): void => {
  const elements =  document.querySelectorAll<HTMLElement>('a[href^="#"]')
  if (elements.length) {
  elements.forEach(anchor => {
      anchor.addEventListener('click', function (e: Event) {
        e.preventDefault()
        const element = this.getAttribute('href')
        const targetBlock: HTMLElement | null = element ? document.querySelector(element) : null
        const offsetTop = 92

        if (targetBlock) {
          const targetOffsetTop = targetBlock.offsetTop - offsetTop
          window.scrollTo({
            top: targetOffsetTop,
            behavior: 'smooth'
          })
        }
      })
    })
  }
}

export default anchor
